const Options = ({data}) => {
    const options = data.some(option => option.desc);
    return (
        <>
            {options && <div className="flex mt-52 p-25r gap-16 text-center j-center">
                {
                    data.map((option, i) =>
                        option.desc &&
                        <div key={i} className="flex col mr-16">
                            <p className="gray fs-16 mb-8">{option.title.toUpperCase()}</p>
                            <p className="regular white">{option.desc}</p>
                        </div>
                    )
                }
            </div>}
        </>
    )
}
export default Options